export default __webpack_public_path__ + "static/Aeonik-Light-770f0c6b6ef6e64a0645ecd3433a48fb.otf";